import React from "react";

export function UserIcon(): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.504"
      height="23.504"
      viewBox="0 0 23.504 23.504"
      fill="currentColor"
    >
      <g id="noun_User_1867975" transform="translate(24 -59)">
        <path
          id="Path_2400"
          data-name="Path 2400"
          d="M21.382,20.7a11.752,11.752,0,1,0-17.267-.008.7.7,0,0,0,.115.126,11.7,11.7,0,0,0,17.021.025A.732.732,0,0,0,21.382,20.7ZM12.752,2.469a10.271,10.271,0,0,1,8.44,16.141,8.751,8.751,0,0,0-5.563-5.8,4.774,4.774,0,1,0-5.763,0A8.782,8.782,0,0,0,4.306,18.6,10.271,10.271,0,0,1,12.752,2.469Zm-.007,9.853a3.305,3.305,0,1,1,3.305-3.305A3.309,3.309,0,0,1,12.745,12.322ZM5.5,20.03a7.333,7.333,0,0,1,14.5.01,10.263,10.263,0,0,1-14.5-.01Z"
          transform="translate(-25 58)"
        />
      </g>
    </svg>
  );
}
